// Lista de países en español, ordenada alfabéticamente. Priorizados los de habla hispana al principio.
export const COUNTRIES = [
  "España", "México", "Argentina", "Colombia", "Chile", "Perú", "Venezuela", "Ecuador",
  "Guatemala", "Cuba", "Bolivia", "República Dominicana", "Honduras", "Paraguay",
  "El Salvador", "Nicaragua", "Costa Rica", "Panamá", "Uruguay", "Puerto Rico",
  "Guinea Ecuatorial",
  // Resto del mundo
  "Afganistán", "Albania", "Alemania", "Andorra", "Angola", "Antigua y Barbuda",
  "Arabia Saudita", "Argelia", "Armenia", "Australia", "Austria", "Azerbaiyán",
  "Bahamas", "Bangladés", "Barbados", "Baréin", "Bélgica", "Belice", "Benín",
  "Bielorrusia", "Birmania", "Bosnia y Herzegovina", "Botsuana", "Brasil", "Brunéi",
  "Bulgaria", "Burkina Faso", "Burundi", "Bután", "Cabo Verde", "Camboya", "Camerún",
  "Canadá", "Catar", "Chad", "China", "Chipre", "Ciudad del Vaticano", "Comoras",
  "Corea del Norte", "Corea del Sur", "Costa de Marfil", "Croacia", "Dinamarca",
  "Dominica", "Egipto", "Emiratos Árabes Unidos", "Eritrea", "Eslovaquia", "Eslovenia",
  "Estados Unidos", "Estonia", "Esuatini", "Etiopía", "Filipinas", "Finlandia", "Fiyi",
  "Francia", "Gabón", "Gambia", "Georgia", "Ghana", "Granada", "Grecia", "Guinea",
  "Guinea-Bisáu", "Guyana", "Haití", "Hungría", "India", "Indonesia", "Irak", "Irán",
  "Irlanda", "Islandia", "Islas Marshall", "Islas Salomón", "Israel", "Italia",
  "Jamaica", "Japón", "Jordania", "Kazajistán", "Kenia", "Kirguistán", "Kiribati",
  "Kuwait", "Laos", "Lesoto", "Letonia", "Líbano", "Liberia", "Libia", "Liechtenstein",
  "Lituania", "Luxemburgo", "Macedonia del Norte", "Madagascar", "Malasia", "Malaui",
  "Maldivas", "Malí", "Malta", "Marruecos", "Mauricio", "Mauritania", "Micronesia",
  "Moldavia", "Mónaco", "Mongolia", "Montenegro", "Mozambique", "Namibia", "Nauru",
  "Nepal", "Níger", "Nigeria", "Noruega", "Nueva Zelanda", "Omán", "Países Bajos",
  "Pakistán", "Palaos", "Palestina", "Papúa Nueva Guinea", "Polonia", "Portugal",
  "Reino Unido", "República Centroafricana", "República Checa",
  "República del Congo", "República Democrática del Congo", "Ruanda", "Rumanía",
  "Rusia", "Samoa", "San Cristóbal y Nieves", "San Marino", "San Vicente y las Granadinas",
  "Santa Lucía", "Santo Tomé y Príncipe", "Senegal", "Serbia", "Seychelles",
  "Sierra Leona", "Singapur", "Siria", "Somalia", "Sri Lanka", "Sudáfrica", "Sudán",
  "Sudán del Sur", "Suecia", "Suiza", "Surinam", "Tailandia", "Tanzania", "Tayikistán",
  "Timor Oriental", "Togo", "Tonga", "Trinidad y Tobago", "Túnez", "Turkmenistán",
  "Turquía", "Tuvalu", "Ucrania", "Uganda", "Uzbekistán", "Vanuatu", "Vietnam", "Yemen",
  "Yibuti", "Zambia", "Zimbabue"
];
